"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSettingsToGql = exports.mapSettingsToVod = void 0;
var tslib_1 = require("tslib");
var pricing_1 = require("../../mappers/pricing");
var mapSettingsToVod = function (settings) {
    var defaultChannelId = settings.defaultChannelId, defaultPricing = settings.defaultPricing, currency = settings.currency, embedLogos = settings.embedLogos, extendOptions = settings.extendOptions;
    return tslib_1.__assign({ defaultChannelId: defaultChannelId, currency: currency, dealInfo: defaultPricing.map(pricing_1.mapSettingsPricingToVod), embedLogos: embedLogos.default.map(function (url) { return ({
            url: url,
            id: url,
        }); }), embedDefaultLogoId: embedLogos.selected }, extendOptions);
};
exports.mapSettingsToVod = mapSettingsToVod;
var mapSettingsToGql = function (settings) {
    var variables = {
        currency: settings.currency,
        defaultChannelId: settings.defaultChannelId,
        defaultPricing: settings.dealInfo.map(pricing_1.mapSettingsPricingToGql),
        embedLogos: settings.embedLogos.map(function (_a) {
            var url = _a.url;
            return url;
        }),
        selectedEmbedLogo: settings.embedDefaultLogoId,
        extendOptions: {},
    };
    Object.keys(settings).forEach(function (key) {
        if (key in variables) {
            return;
        }
        if (key === 'dealInfo') {
            return;
        }
        variables.extendOptions[key] = settings[key];
    });
    return variables;
};
exports.mapSettingsToGql = mapSettingsToGql;
//# sourceMappingURL=settings.mappers.js.map